import React, { Component } from 'react'
import { connect } from 'react-redux'
import { func, string, bool } from 'prop-types'

import { renderItemType } from 'models/propTypes'

import { ART_ITEM } from 'constants/renderItemTypes'
import { getSelectedRenderItem } from 'models/compositions/selectors'
import { getRegion } from 'models/location/selectors'
import { getCanEditArtSize } from 'models/admin/selectors'
import { updateSelectedCompositionRenderItem } from 'models/compositions/actions'
import OptionSelectorView from 'components/designSidepanel/OptionSelectorView'
import { ART_FRAMES, ART_SIZES } from 'models/furniture/artConstants'
import { getProductTrackingInfo } from 'models/tracking/utils'

class OptionSelectorViewContainer extends Component {
    constructor(props) {
        super(props)
        this.updateRenderItem = this.updateRenderItem.bind(this)
    }

    updateRenderItem(settings) {
        const item = { ...settings }
        const { selectedRenderItem: artItem } = this.props

        if (!item.matteId && item.frameId) {
            if (!ART_FRAMES[item.frameId].mattes[artItem.matteId]) {
                item.matteId = parseInt(Object.keys(ART_FRAMES[item.frameId].mattes)[0], 10)
            }
        }
        const productTrackingInfo = getProductTrackingInfo(artItem)
        const trackingInfo = {
            ...productTrackingInfo,
            OriginalProperties: {},
            FinalProperties: {},
        }
        if (item.frameId) {
            trackingInfo.OriginalProperties.frameId = artItem.frameId
            trackingInfo.FinalProperties.frameId = item.frameId
        }
        if (item.matteId) {
            trackingInfo.OriginalProperties.matteId = artItem.matteId
            trackingInfo.FinalProperties.matteId = item.matteId
        }
        if (item.colorId) {
            trackingInfo.OriginalProperties.colorId = artItem.colorId
            trackingInfo.FinalProperties.colorId = item.colorId
        }
        if (item.sizeId) {
            trackingInfo.OriginalProperties.sizeId = artItem.sizeId
            trackingInfo.FinalProperties.sizeId = item.sizeId
        }
        if (item.customHeight || item.sizeId) {
            trackingInfo.OriginalSize = artItem.customHeight || artItem.size.height
            trackingInfo.FinalSize = item.customHeight || ART_SIZES[item.sizeId].height
        }
        this.props.updateSelectedCompositionRenderItem(item, trackingInfo)
    }

    render() {
        const { selectedRenderItem, locale, canEditArtSize } = this.props
        if (!selectedRenderItem || selectedRenderItem.renderType !== ART_ITEM) {
            return null
        }
        return (
            <OptionSelectorView
                selectedRenderItem={selectedRenderItem}
                updateRenderItem={this.updateRenderItem}
                locale={locale}
                canEditArtSize={canEditArtSize}
            />
        )
    }
}

OptionSelectorViewContainer.defaultProps = {
    selectedRenderItem: null,
}

OptionSelectorViewContainer.propTypes = {
    selectedRenderItem: renderItemType,
    updateSelectedCompositionRenderItem: func.isRequired,
    locale: string.isRequired,
    canEditArtSize: bool.isRequired,
}

const mapStateToProps = (state) => ({
    selectedRenderItem: getSelectedRenderItem(state),
    locale: getRegion(state),
    canEditArtSize: getCanEditArtSize(state),
})

const mapDispatchToProps = (dispatch) => ({
    updateSelectedCompositionRenderItem: (...args) => dispatch(updateSelectedCompositionRenderItem(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OptionSelectorViewContainer)
